import React, { useRef } from 'react';
// import { CnIcon } from '@sto/cn-ui'; // 根据实际路径导入
import styles from './index.module.scss';
import { uploadAndGetOssFile } from '$src/services/fetchs';

interface ImageUploaderProps {
  submit: (url: string, fileType: 'image' | 'file', fileName: string, fileSize: string) => void; // 回调函数，接收上传的文件 URL、类型、文件名和大小
  accept?: string; // 可选：指定接受的文件类型，默认接受所有文件
}

const ImageUploader: React.FC<ImageUploaderProps> = ({ submit, accept }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const formatFileSize = (bytes: number) => {
    if (bytes < 1024) {
      return `${bytes}B`;
    } else if (bytes < 1024 * 1024) {
      return `${Math.round(bytes / 1024)}KB`;
    } else {
      return `${(bytes / 1024 / 1024).toFixed(1)}MB`;
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const isImage = file.type.startsWith('image/');
      const fileType: 'image' | 'file' = isImage ? 'image' : 'file';
      const fileName = file.name || '未命名文件';
      const fileSize = formatFileSize(file.size);
      
      const formData = new FormData();
      formData.append('file', file);
      formData.append('bizType', 'DING_CHAT_RECORD');
      uploadImage(formData)
        .then((url) => {
          submit(url, fileType, fileName, fileSize); // 调用回调函数，将 URL、文件类型、文件名和大小返回给父组件
          if (fileInputRef.current) {
            fileInputRef.current.value = ''; // 重置文件输入
          }
        })
        .catch((error) => {
          console.error('Upload failed:', error);
        });
    }
  };

  const uploadImage = async (formData: FormData): Promise<string> => {
    const {
      data: { tempUrl },
    } = await uploadAndGetOssFile(formData);

    return tempUrl; // 返回文件的临时 URL
  };

  return (
    <label htmlFor="file-upload" style={{ width: 18, height: 18 }}>
      <img
        className={styles.uploadImg}
        src="https://imgcdn.sto.cn/8F11D7B6-97CC-4F-36x36-uploadImg.png"
        alt="upload"
      />
      <input
        id="file-upload"
        ref={fileInputRef}
        type="file"
        accept={accept} // 支持自定义文件类型，不设置则接受所有文件
        onChange={handleFileChange}
        style={{ display: 'none' }} // 隐藏默认的文件上传输入框
      />
    </label>
  );
};

export default ImageUploader;
